import React, { useState } from "react";
import { TableDateRange } from "../../common/components/TableDateRange";
import { useQuery } from "react-query";
import { AxiosPositionsAPI } from "../Api";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";

const PositionHistoryTable = ({
  positionrecord_set,
  ordering,
  setOrdering,
}) => {
  const rows = positionrecord_set.map((el) => ({
    id: el.id,
    startDate: el.timespan.lower,
    endDate: el.timespan.upper,
  }));

  return (
    <TableDateRange data={rows} ordering={ordering} setOrdering={setOrdering} />
  );
};

export const PositionHistoryList = ({ position_id }) => {
  const [ordering, setOrdering] = useState(null);

  const { data, error } = useQuery(
    ["positionRecords", position_id, ordering],
    () => AxiosPositionsAPI.getRecords(position_id, ordering),
  );

  if (error) return <ErrorSegment message={error.message} />;
  if (data === undefined) return <Loader active />;
  if (data)
    return (
      <PositionHistoryTable
        positionrecord_set={data.results}
        ordering={ordering}
        setOrdering={setOrdering}
      />
    );

  return null;
};
